import {tagSvg as Icon__small__tagSvg} from '../Icon__small/Icon__small--tag.js'

export var tag = {
  name: 'tag',
  category: 'icon',
  colorable: true,
  svg: Icon__small__tagSvg,
};
